// extracted by mini-css-extract-plugin
module.exports = {"add-button":"Step3Price_add-button_1YYGR"};